export const I18N = {
    de: {
        totalElementText: 'Datensätze',
        noData: 'Keine Daten vorhanden'
    },
    en: {
        totalElementText: 'Records',
        noData: 'No data available'
    }
};
